import { render, staticRenderFns } from "./GvsNosologiaPage.vue?vue&type=template&id=21daba0f&"
import script from "./GvsNosologiaPage.vue?vue&type=script&lang=js&"
export * from "./GvsNosologiaPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports